<template>
  <section class="policy-invoice main">
    <h3>Policy Docs</h3>
    <div
      v-if="isManual"
      class="abs-top-right">
      <v-button
        icon="plus"
        plain
        type="primary"
        @click="onAddRecord">Add Record</v-button>
    </div>
    <section v-if="!isManual">
      <div class="main flex-sb">
        <div class="left">
          <div
            class="period-item active"
          >
            <span class="bold">{{ form.type_language }}</span>
            <span>{{ form.policy_period }}</span>
          </div>
        </div>
        <div class="container flex-1">
          <div
            class="card card-table table-gray"
          >
            <div class="header flex-sb">
              <div>
                <span class="title">{{ form.type_language }}</span>
                <span class="date">{{ form.policy_period }}</span>
              </div>
            </div>
            <el-table
              :data="tableData"
              :show-header="false"
              style="width: 100%">
              <el-table-column
                prop="doc"
                width="140"></el-table-column>
              <el-table-column prop="client_name">
                <template #default="{row}">
                  <span
                    class="blue pointer"
                    @click="openFile(row.url)"
                  >{{ row.client_name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="client_name"
                width="120">
                <template #default="{row}">
                  <span
                    v-if="row && row.url"
                    class="blue pointer"
                    @click="handlerDownloadName(row)"
                  >Download</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="upload_date"
                width="190"></el-table-column>
            </el-table>
            <!-- <el-table
              :data="tableData"
              :header-row-class-name="'tableHeader'"
              style="width: 100%">
              <el-table-column label="Document">
                <template #default="scope">
                  {{scope}}
                  <span
                    class="text-line"
                  >{{ scope.row.client_name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="File">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="blue pointer"
                    :class="{
                      'text-line':  ((record.stts == 0 || (record.stts == 410 && record.type == 10 && hasAdjust)) && !scope.row.isBrochure)
                    }"
                    @click="openFile(scope.row.file.url)"
                  >{{ scope.row.file.client_name }}</span>
                  <span
                    v-else
                    class="missing">No File</span>
                </template>
              </el-table-column>
              <el-table-column label="Action">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="blue pointer"
                    @click="handlerDownloadName(scope.row)"
                  >Download</span>
                  <v-button
                    v-if="scope.row.action"
                    type="text"
                    :stop="true">{{ scope.row.action }}</v-button>
                </template>
              </el-table-column>
              <el-table-column
                label="Date"
                prop="upload_date"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.upload_date"
                    class="span-time">{{scope.row.file.upload_date}}</span>
                </template>
              </el-table-column>
            </el-table> -->
          </div>
          <!-- <div
            v-for="(record, rIndex) in invoice.record"
            :key="rIndex"
            class="card">
            <div class="header flex-sb">
              <div>
                <span class="title">{{ record.type_language }}</span>
                <span class="date">{{ record.period_start }}</span>
              </div>
              <div>
                <v-button
                  type="primary"
                  @click="handlerEdit(index, rIndex)">Edit</v-button>
              </div>
            </div>
            <el-table
              :data="record.data"
              stripe
              style="width: 100%">
              <el-table-column
                prop="document"
                label="Document"></el-table-column>
              <el-table-column
                prop="from"
                label="From"></el-table-column>
              <el-table-column
                prop="uploaded_by"
                label="Uploaded By"></el-table-column>
              <el-table-column
                label="File">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="blue pointer"
                    @click="openFile(scope.row.file.url)">{{ scope.row.file.client_name }}</span>
                  <span
                    v-else
                    class="missing">Missing</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Action">
                <template slot-scope="scope">
                  <v-button
                    v-if="scope.row.action"
                    type="text"
                    :stop="true">{{ scope.row.action }}</v-button>
                </template>
              </el-table-column>
            </el-table>
          </div>-->
        </div>
      </div>
    </section>

    <v-dialog
      v-model="dialog"
      width="700px">
      <div class="dialog-container">
        <div
          v-if="!isManual"
          class="dialog-header">
          <h3>{{ recordData.type_language }}</h3>
          <span class="date">{{ recordData.period_start }}</span>
        </div>
        <div v-else>
          <h3>Edit Policy & Invoice</h3>
          <div
            v-if="!isEditNewPolicy"
            class="form-item form-half">
            <span>{{action_type_lang}}</span>
            <v-date-picker v-model="formData.pcy_cmnt_dt" />
          </div>
        </div>
        <el-table
          v-if="!isAdd"
          :data="recordData.data || []"
          stripe
          style="width: 100%">
          <el-table-column
            prop="document"
            label="Document"></el-table-column>
          <el-table-column
            prop="from"
            label="From"></el-table-column>
          <el-table-column
            prop="uploaded_by"
            label="Uploaded By"></el-table-column>
          <el-table-column label="File">
            <template slot-scope="scope">
              <section>
                <span
                  v-if="scope.row.file && scope.row.file.url"
                  class="blue pointer"
                  @click="openFile(scope.row.file.url)"
                >{{ scope.row.file.client_name }}</span>
                <span
                  v-else
                  class="missing">No File</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
          >
            <template slot-scope="scope">
              <span
                v-if="['pcy_pdf_path', 'cvr_pdf_path','extra_car_wind_pro_path','extra_drvr_acc_path'].includes(scope.row.type)"
                class="pointer blue"
                @click="handlerUpload(scope.row, scope.$index)">
                {{ (scope.row.file && scope.row.file.url)? 'Replace': 'Upload' }}
              </span>
              <v-upload
                v-else
                btnType="text"
                :uploadData="{
                  order_id: recordData.id,
                  type: scope.row.type
                }"
                :otherData="{
                  index: scope.$index
                }"
                :direct="0"
                :label="(scope.row.file && scope.row.file.url)? 'Replace': 'Upload'"
                @uploadSuccess="handlerUploadSuccess"
              />
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span
                v-if="scope.row.file && scope.row.file.url"
                class="danger pointer"
                @click="handlerDelete(scope.$index, scope.row.type)"
              >Delete</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-footer flex-sb">
          <div>
            <v-button @click="onCloseDialog">Close</v-button>
          </div>
          <div v-if="!isEditNewPolicy">
            <v-button
              type="primary"
              @click="onConfirm">Confirm</v-button>
          </div>
        </div>
      </div>
    </v-dialog>

    <v-dialog
      v-model="addDialog"
      width="370px">
      <div class="dialog-container">
        <h3>Add Record</h3>
        <div class="btn-list">
          <v-button @click="onRecordType(1)">Endorsement</v-button>
          <v-button @click="onRecordType(2)">Cancellation</v-button>
        </div>
        <div class="dialog-footer">
          <v-button @click="addDialog = false">Cancel</v-button>
        </div>
      </div>
    </v-dialog>

    <upload-cover-note
      ref="upload-cover-note"
      :form="form"
      :orderId="recordData.id"
      :changeUploadData="changeUploadData"
      @success="handlerUploadCoverNoteSuccess" />
    <official-policy
      ref="official-policy"
      :form="form"
      :orderId="recordData.id"
      :changeUploadData="changeUploadData"
      @success="handlerUploadOfficialPolicySuccess" />
    <extra-benefits-policy
      ref="extra-policy"
      :form="form"
      :orderId="recordData.id"
      :changeUploadData="changeUploadData"
      @success="handlerUploadExtraPolicySuccess" />

  </section>
</template>
<script>
import {deleteExtraFile, deleteOrderFile} from '@/api/order'
import {addManualPolicyInvoice, editManualPolicyInvoice} from '@/api/policy'
import UploadCoverNote from './dialog/endorsement-dailog'
import OfficialPolicy from './dialog/official-policy'
import ExtraBenefitsPolicy from './dialog/wind_policy_dialog'
import {downloadFileName} from '@/utils/download'

export default {
  name: 'PolicyInvoice',
  components: {
    UploadCoverNote,
    OfficialPolicy,
    ExtraBenefitsPolicy
  },
  props: {
    invoice: {
      type: [Object, Array],
      default: () => ({}),
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      action_type: 0,
      action_type_lang:'',
      invoiceList: [],
      changeUploadData:{},
      dialog: false,
      recordData: {},
      invoiceIndex: -1,
      recordIndex: -1,
      hasAdjust: false,
      addDialog: false,
      formData: {
        action: 1, // 1.Endorsement,2.Cancel
        pcy_cmnt_dt: ''
      },
      isAdd: false,
      uploadIndex: -1,
      tableData: []
    }
  },
  computed: {
    // policyPeriods() {
    //   return this.invoice.policy_periods
    // },
    isEditNewPolicy() {
      return !this.isAdd && this.action_type == 10
    }
  },
  watch: {
    invoice: {
      deep: true,
      immediate: true,
      handler(val) {
        if (JSON.stringify(val) != '{}') {
          // 過濾一下 ?
          const value = JSON.parse(JSON.stringify(val))
          this.handler().handlerInvoiceList(value)
        }
      },
    },
    form:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.pcy_pdf){
          this.handler().createTable('Official Policy',val.pcy_pdf)
        }
        if(val.inv_pdf){
          this.handler().createTable('Invoice',val.inv_pdf)
        }
        if(val.rec_pdf){
          this.handler().createTable('Receipt',val.rec_pdf)
        }
        if(val.confirmation_pdf){
          this.handler().createTable('Confirmation',val.confirmation_pdf)
        }
        if(val.endorse_file){
          this.handler().createTable('Endorsement',val.endorse_file)
        }

      }
    }
  },
  methods: {
    handlerDownloadName(item){
      let document='Official Policy'
      let {url,client_name} = item||{}
      const name = document.replace(/\s/g,'')
      const [,suffix] = client_name.split('.')
      if(url)
        downloadFileName(url, `${name}.${suffix}`)
    },
    onAddRecord() {
      this.formData.pcy_cmnt_dt = ''
      this.addDialog = true
    },
    onRecordType(type) {
      this.formData.action = type
      this.action_type_lang = type===1?'Endorsement':'Cancellation'
      this.addDialog = false
      this.isAdd = true
      this.dialog = true
    },
    onCloseDialog() {
      this.dialog = false
      this.isAdd = false
    },
    onConfirm() {
      if(this.isManual) {
        if(this.isAdd) {
          this.network().addManualPolicyInvoice()
        }
        else {
          this.network().editManualPolicyInvoice()
        }
      }
      else {
        this.dialog = false
        this.isAdd = false
      }
    },
    openFile(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    handlerManualEdit(index) {
      // this.recordData = this.invoiceList[index]
      this.recordData = {
        id: this.invoiceList[index].id,
        data: this.invoiceList[index].record
      }
      const invoiceItem = this.invoiceList[index]
      const { type, type_language, pcy_cmnt_date } = invoiceItem

      this.action_type = type
      this.action_type_lang = type_language

      this.formData.pcy_cmnt_dt = pcy_cmnt_date

      this.isAdd = false
      this.dialog = true
    },
    handlerEdit(recordIndex) {
      this.recordData = this.invoiceList.record[recordIndex]
      // this.invoiceIndex = index
      this.isAdd = false
      this.recordIndex = recordIndex
      this.dialog = true
      // this.action_type_lang = this.invoiceList[index].type_language
      this.action_type_lang = this.recordData.type_language

    },
    handlerUpload(row, index) {
      this.uploadIndex = index
      const { type } = row
      this.changeUploadData = row
      if(type == 'pcy_pdf_path') {
        this.$refs['official-policy'].changeDialog()
      }
      if(type == 'extra_car_wind_pro_path'||type=='extra_drvr_acc_path') {
        this.$refs['extra-policy'].changeDialog()
      }
      if(type == 'cvr_pdf_path') {
        this.$refs['upload-cover-note'].changeDialog()
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { index } = otherData

      const { type } = this.recordData.data[index]

      let resultData = {
        ...this.recordData.data[index],
        file: data,
        from: 'HoldCover',
        uploaded_by: 'HoldCover'
      }

      // if(type === 'other') {
      //   const otherIndex = this.recordData.data[index].index
      //   result = {
      //     ...result,
      //     index: otherIndex
      //   }
      // }
      this.$set(this.recordData.data, index, resultData)
      this.$emit('update')
      if (!this.isManual) {
        // this.invoiceList[this.invoiceIndex].record[this.recordIndex].file = data
        this.$set(
          this.invoiceList.record[this.recordIndex].data,
          index,
          resultData
        )
      }
    },
    handlerManualUploadSuccess({ data, result, otherData }) {
      const { index, recordIndex } = otherData

      let resultData = {
        ...this.invoiceList[index].record[recordIndex],
        file: data,
        from: 'HoldCover',
        uploaded_by: 'HoldCover'
      }
      this.$emit('update')
      this.$set(
        this.invoiceList[index].record,
        recordIndex,
        resultData)

      // const { type } = this.invoiceList[index]
      // this.invoiceList[index].file = data

      // if(type === 'other') {
      //   this.invoiceList[index].file = [data]
      // }
      // else {
      //   this.invoiceList[index].file = data
      // }
    },
    handlerDelete(index, type, invoiceIndex) {
      if(type == 'extra_car_wind_pro_path'||type=='extra_drvr_acc_path'){
        this.network().deleteExtraFile(index, type, invoiceIndex)
      }
      else this.network().deleteOrderFile(index, type, invoiceIndex)
    },
    handlerUploadCoverNoteSuccess(data) {
      // this.$emit('update')
      const { cvr_pdf } = data
      this.handlerUploadSuccess({
        data: cvr_pdf,
        otherData: {
          index: this.uploadIndex
        }
      })
      this.$emit('update')
    },
    handlerUploadOfficialPolicySuccess(data) {
      const { pcy_pdf } = data
      this.handlerUploadSuccess({
        data: pcy_pdf,
        otherData: {
          index: this.uploadIndex
        }
      })
      this.$emit('update')
    },
    handlerUploadExtraPolicySuccess(data,key) {
      this.handlerUploadSuccess({
        data: data[key],
        otherData: {
          index: this.uploadIndex
        }
      })
      this.$emit('update')
    },
    handler() {
      return {
        getHandlerData: (data = []) => {
          return data.reduce((result, item) => {
            if (item.type === 'other') {
              const { file } = item
              if (file) {
                for (let i = 0; i < file.length; i++) {
                  result.push({
                    ...item,
                    index: i,
                    file: file[i],
                  })
                }
              } else {
                result.push({
                  ...item,
                  index: 0,
                  file: null,
                })
              }
            } else if (item.document == 'Brochure') {
              result.push({
                ...item,
                isBrochure: true,
              })
            } else {
              result.push(item)
            }
            return result
          }, [])
        },
        handlerInvoiceList: (invoiceData) => {
          let result = []
          let temp
          if (this.isManual) {
            temp = JSON.parse(JSON.stringify(invoiceData))
            temp.map((item) => {
              item.record = this.handler().getHandlerData(item.record)
              return item
            })
            result = temp
          } else {
            temp = JSON.parse(JSON.stringify(invoiceData))
            // result = temp.reduce((invoiceResult, item) => {
            temp.record.map((recordItem) => {
              recordItem.data = this.handler().getHandlerData(recordItem.data)
              return recordItem
            })
            //   invoiceResult.push(item)
            //   return invoiceResult
            // }, [])
            result = temp
            // 檢查是否存在 adjust
            result.record.some((item) => {
              if (item.type == 50 && item.stts == 410) {
                this.hasAdjust = true
                return true
              }
            })
          }
          this.invoiceList = result
        },
        createTable: (doc,obj) => {
          let new_obj={
            doc,
            client_name:obj.client_name,
            id:obj.id,
            path:obj.path,
            thumb_url:obj.thumb_url,
            upload_date:obj.upload_date,
            url:obj.url
          }
          this.tableData.push(new_obj)
        }
      }
    },

    network() {
      return {
        addManualPolicyInvoice: async () => {
          const { data } = await addManualPolicyInvoice({
            order_id: this.orderId,
            action: this.formData.action,
            pcy_cmnt_dt: this.formData.pcy_cmnt_dt
          })
          this.dialog = false
          this.$emit('update')
        },
        editManualPolicyInvoice: async () => {
          const { data } = await editManualPolicyInvoice({
            order_id: this.orderId,
            pcy_cmnt_dt: this.formData.pcy_cmnt_dt,
            file_data: this.recordData.data
          })
          this.dialog = false
          this.$emit('update')
        },
        deleteOrderFile: async (index, type, invoiceIndex = -1) => {
          const { data } = await deleteOrderFile({
            order_id: invoiceIndex !== -1 ?
              this.invoiceList[invoiceIndex].id : this.recordData.id,
            type,
          })
          this.$message({
            type: 'success',
            message: data.message_language,
          })

          let localData = invoiceIndex != -1
            ? this.invoiceList[invoiceIndex].record[index]
            : this.recordData.data[index]
          const params = {
            ...localData,
            file: null,
            from: '',
            uploaded_by: '',
          }
          if (invoiceIndex == -1) {
            this.$set(this.recordData.data, index, params)
          }

          // 更新表格数据
          if (this.isManual) {
            this.$set(this.invoiceList[invoiceIndex].record, index, params)
            // this.invoiceList[index] = params
          } else {
            this.$set(
              this.invoiceList.record[this.recordIndex].data,
              index,
              params
            )
          }
        },
        deleteExtraFile: async (index, type, invoiceIndex = -1) => {
          const { data } = await deleteExtraFile({
            order_id: invoiceIndex !== -1 ?
              this.invoiceList[invoiceIndex].id : this.recordData.id,
            type:type+'_id',
          })
          this.$message({
            type: 'success',
            message: data.message_language,
          })
          let localData = invoiceIndex != -1
            ? this.invoiceList[invoiceIndex].record[index]
            : this.recordData.data[index]
          const params = {
            ...localData,
            file: null,
            from: '',
            uploaded_by: '',
          }
          if (invoiceIndex == -1) {
            this.$set(this.recordData.data, index, params)
          }

          // 更新表格数据
          if (this.isManual) {
            this.$set(this.invoiceList[invoiceIndex].record, index, params)
            // this.invoiceList[index] = params
          } else {
            this.$set(
              this.invoiceList.record[this.recordIndex].data,
              index,
              params
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.policy-invoice {
  position: relative;
  .abs-top-right {
    top: 5px;
  }
  .main {
    padding-top: 10px;
    .left {
      margin-right: 15px;
      width: 200px;
      .active {
        background: #d9ecff;
      }
      .period-item {
        padding: 8px;
        color: #409eff;
        font-size: 12px;
        .bold {
          display: block;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
    // .container {
    // }
  }
  .card {
    // margin-bottom: 20px;
    padding: 15px;
    border-radius: 6px;
    &.card-table{
      padding: 0!important;
      .header{
        background: #F6F8FA;
        border-radius: 6px 6px 0 0;
        border: 1px solid #D1D5DA;
        padding: 15px 13px;
        .edit-span{
          font-family: Inter;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: #0366D6;
          cursor: pointer;
        }
      }
      .span-time{
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #6A737D;
      }
      .el-table{
        ::v-deep .tableHeader{
          display: none;
        }
        border: 1px solid #D1D5DA;
        border-top: 0;
        //border-bottom: 0;
        //border-bottom: 0;
        border-radius: 0 0 6px 6px;
        ::v-deep td{
          border-bottom: 1px solid #D1D5DA;
          padding: 10px 0!important;
          .cell{
            padding-left: 15px;
          }
        }
        ::v-deep tr{
          &:last-child{
            td{
              border-bottom: 0;
            }
          }
        }
      }
    }

  }
  .manual-header {
    padding-bottom: 15px;
    text-align: right;
  }
  .header {
    align-items: center;
    padding-top: 0;
    .title {
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
    .date {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      padding-left: 10px;
      color: #6A737D;
    }
  }
  .missing {
    color: #91939a;
    font-size: 12px;
    font-style: italic;
  }
  .dialog-container {
    padding: 15px;
    .missing {
      color: #91939a;
      font-size: 12px;
      font-style: italic;
    }
    .danger {
      color: #f56c6d;
    }
    .dialog-header {
      color: #616266;
      h3 {
        display: inline-block;
        padding-right: 15px;
      }
      .date {
        font-size: 16px;
      }
    }
    .btn-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-button {
        display: block;
        margin: 0 auto 10px auto!important;
      }
    }
    .dialog-footer {
      padding-top: 15px;
    }
  }
  .danger {
    color: #f56c6d;
  }
  .pd-l-10 {
    display: inline-block;
    padding-left: 10px;
  }
  .btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

}
</style>
<style lang="scss">
.bg{
  background:white;
  padding:15px;
  border: 1px solid #D1D5DA;
  border-top: 0;
  border-radius: 0 0 6px 6px !important;
}
.table-gray {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  background: #eeeeee;
  /deep/ .el-table {
    background: #eeeeee;
    /deep/ tr,
    /deep/ th {
      background: #eeeeee !important;
      &.el-table__row--striped {
        td {
          background: rgba(0, 0, 0, 0.02);
        }
      }
    }
  }
}
</style>
